module.exports = __webpack_public_path__ + "img/service_icon3-pressed.f019fa5e.png";